import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import * as moment from "moment-timezone";
import { sweetAlert } from "src/app/utils/swal";
import { MemberService } from "../member-service/member.service";
import { DriversService } from "../../drivers/drivers-service/drivers-service";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { skip, takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import * as _ from 'underscore';


@Component({
  selector: "app-member-list",
  templateUrl: "./member-list.component.html",
  styleUrls: ["./member-list.component.css"],
})
export class MemberListComponent implements OnInit, OnDestroy {
  @ViewChild('scrollContainer', { static: true }) scrollContainer: any;
  members = []
  selectedMembers= []
  assignDriverArray = [];
  user;
  selecetedMember;
  search;
  status = "active";
  throughApi = true;
  isAllMemberSelected = false;
  showSlideFilter: boolean = false;
  memberStatusObj;
  p: number = 1;
  memberTripsObj: any;

  constructor(
    private memberService: MemberService,
    private sharedDataService: SharedDataService
  ) {
  }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          // this.getMembers();
        }
      });
  }

  onChangeStatus() {
    // this.getMembers();
  }
  onChangeAPI(evt){
    this.throughApi = JSON.parse(evt);
    // this.getMembers();
  }
  getMembers() {
    // const queryParam = {
    //   accountStatus: this.status,
    //   limit: 50,
    // }
    // this.memberService
    //   .getMembers(queryParam)
    //   .pipe(takeUntil(componentDestroyed(this)))
    //   .subscribe(data => {
    //     if (data) {
    //       this.members = data;
    //     }
    //   });
  }

  onSelectMember(member) {
    const index = this.selectedMembers.indexOf(member._id);
    if (index > -1) {
      member.isSelected = false;
      this.selectedMembers.splice(index, 1);
    } else {
      member.isSelected = true;
      this.selectedMembers.push(member._id);
    }
  }

  selectAllTrips() {
    this.members.forEach((member) => {
      member.isSelected = true;
      if (!this.selectedMembers.includes(member._id))
        this.selectedMembers.push(member._id);
    });
    // }

    this.isAllMemberSelected =
      this.selectedMembers.length === this.members.length;
    return this.isAllMemberSelected;
  }


  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  openStatusModal(){
    this.memberStatusObj = this.selectedMembers
  }


  unSelectAllTrips() {
    const unSelectedMembers = [];
    this.members.forEach((member) => {
      member.isSelected = false;
      unSelectedMembers.push(member._id);
    });

    this.selectedMembers = this.selectedMembers.filter(x => !unSelectedMembers.includes(x));
    this.isAllMemberSelected = false;
  }

  getSelectedTrips() {
    return this.selectedMembers
      .filter((member) => member.isSelected);

  }

  assignDriver(member) {
    this.selecetedMember = JSON.parse(JSON.stringify(member));
    this.assignDriverArray = [];
    let object = this.getAllDays();
    for (let i = 0; i < this.selecetedMember.scheduler.length; i++) {
      object = object.map((item) => {
        if (item.day === this.selecetedMember.scheduler[i].day) {
          item.driver = this.selecetedMember.scheduler[i].driver;
          item.isSelect = true;
        }
        return item;
      });
    }
    this.assignDriverArray = object;
  }

  saveModalData() {
    this.selecetedMember.scheduler = this.assignDriverArray.filter(
      (item) => item.isSelect && item.driver !== ""
    );

    this.memberService
      .updateMember(this.selecetedMember)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.members.filter((obj) => {
              if (obj._id === data._id) {
                // obj.scheduler =  data.scheduler;
                obj.updatedAt =  data.updatedAt;
              }
            });
        }
      });
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id;
  }


  getAllDays() {
    const weekdays = moment.weekdaysShort();
    let object = [];
    for (let i = 0; i < weekdays.length; i++) {
      const innerObject = {
        day: weekdays[i],
        driver: "",
        isSelect: false,
      };
      object.push(innerObject);
    }
    return object;
  }

  memberListUpdated(evt) {
    if (evt) {
      this.members = evt;
    } else {
      this.members = [];
    }

    this.selectedMembers = [];
    this.isAllMemberSelected = false;
  }

  onMemberStatusUpdate(evt) {
    if (evt) {
      if (this.status !== evt.status) {
        this.members = this.members.filter(member => !this.memberStatusObj.includes(member._id));
        this.selectedMembers = [];
      }
    }
    this.memberStatusObj = null;
  }

  openMemberTrips(trips){
    this.memberTripsObj = trips
  }
  closeMemberTrips(trips){
    this.memberTripsObj = null
  }

  ngOnDestroy(): void {
  }
}
